/**
 * Marken-Claim („Pure Alpine Longevity") bündig unter der Wortmarke:
 * misst Logo- und Textbreite und setzt die Laufweite so, dass der Claim links und rechts
 * genau an den Logo-Kanten endet. Ergebnis als --alp-tagline-ls an .header-logo
 * (Fallback ohne JS: feste Laufweite aus alpinulin.css, mittig).
 */
(function () {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  function fit(logo) {
    var img = logo.querySelector('.header-logo__image-container:not([hidden]) img, img');
    if (!img || !img.offsetWidth) return;
    var cs = getComputedStyle(logo, '::after');
    var text = (cs.content || '').replace(/^["']|["']$/g, '');
    if (!text || text === 'none') return;
    if (cs.textTransform === 'uppercase') text = text.toUpperCase();
    ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var natural = ctx.measureText(text).width;
    var gaps = Math.max(1, text.length - 1);
    var ls = (img.getBoundingClientRect().width - natural) / gaps;
    // nie enger als 0.05em, nie breiter als 0.6em — bei Ausreißern lieber mittig lassen
    var fontPx = parseFloat(cs.fontSize) || 9;
    if (ls < fontPx * 0.05 || ls > fontPx * 0.6) return;
    logo.style.setProperty('--alp-tagline-ls', ls.toFixed(2) + 'px');
  }

  function run() {
    document.querySelectorAll('.header-logo').forEach(function (logo) {
      var img = logo.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () { fit(logo); }, { once: true });
      fit(logo);
    });
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 120); });
})();
